/**
 * @description post message 유틸
 * @class PostMessageUtil
 */
class PostMessageUtil {
  constructor() {
    this.init = this.init.bind(this);
    this.receiveMessage = this.receiveMessage.bind(this);
    this.resetParentFrame = this.resetParentFrame.bind(this);
    this.parentPostMessage = this.parentPostMessage.bind(this);
  }

  init() {
    window.addEventListener('message', this.receiveMessage);
  }

  receiveMessage(e) {
    try {
      const { data } = e;

      switch (data.type) {
        case 'resize':
          this.resetParentFrame(null, data.type);
          break;
      }
    } catch (error) {
      console.log('recevieMessage error');
    }
  }

  resetParentFrame(targetHeight, type) {
    let data = {
      method: 'resize',
      height: 0,
      src: window.location.href,
      type: type
    };

    if (targetHeight) {
      data.height = targetHeight;
    } else {
      let contentHeight = 1000;

      try {
        contentHeight = document.getElementById('app').clientHeight;
      } catch (e) {}

      data.height = contentHeight;
    }

    try {
      window.parent.postMessage(JSON.stringify(data), '*');
    } catch (e) {
      console.log("resetParentFrame() mixin : Can't access parent.");
      console.log(e);
    }
  }

  /**
   *
   *
   * @param {*} data
   * @memberof PostMessageUtil
   */
  parentPostMessage(data) {
    try {
      window.parent.postMessage(data, '*');
    } catch (e) {
      console.log("parentPostMessage() mixin : Can't access parent.");
      console.log(e);
    }
  }
}

export default PostMessageUtil;
